import type { RouteLocationNormalizedLoaded } from "vue-router";
import type { Composer } from "vue-i18n";
import { brandName } from "@/constants/brand";
import { configStringValue } from "@/utils/configFlag";

type TranslateFn = Composer["t"];

function routeTitleKey(
  route: RouteLocationNormalizedLoaded,
  bookingPage?: number,
): string {
  const name = String(route.name ?? "");

  switch (name) {
    case "Search":
      return "message.PAGE_TITLE_SEARCH";
    case "Wizard":
      return "message.PAGE_TITLE_WIZARD";
    case "StepByStep":
      return "message.PAGE_TITLE_STEP_BY_STEP";
    case "Comparison":
      return "message.PAGE_TITLE_COMPARISON";
    case "MobileUpload":
      return "message.PAGE_TITLE_MOBILE_UPLOAD";
    case "Tariff":
      return "message.PAGE_TITLE_TARIFF";
    case "assessment":
      return "message.PAGE_TITLE_ASSESSMENT";
    case "Booking":
      if (bookingPage === 4) return "message.PAGE_TITLE_BOOKING_COMPLETE";
      if (bookingPage === 3) return "message.PAGE_TITLE_BOOKING_REVIEW";
      if (bookingPage === 2) return "message.PAGE_TITLE_BOOKING_STEP2";
      return "message.PAGE_TITLE_BOOKING";
    case "Verification":
      return "message.PAGE_TITLE_VERIFICATION";
    case "resumeBooking":
      return "message.PAGE_TITLE_RESUME_BOOKING";
    case "confirmCode":
      return "message.PAGE_TITLE_RESUME_BOOKING";
    case "contractRenewal":
      return "message.PAGE_TITLE_CONTRACT_RENEWAL";
    case "NotFound":
      return "message.PAGE_TITLE_NOT_FOUND";
    case "AccessibilityStatement":
      return "message.PAGE_TITLE_ACCESSIBILITY";
    default:
      return "message.PAGE_TITLE_DEFAULT";
  }
}

/** i18n key for the page’s single visually hidden (or primary) `<h1>`. */
export function routePageHeadingKey(
  route: RouteLocationNormalizedLoaded,
  bookingPage?: number,
): string {
  return routeTitleKey(route, bookingPage).replace(
    "PAGE_TITLE_",
    "PAGE_HEADING_",
  );
}

function resolveSiteName(): string {
  const contactPerson = configStringValue(
    window?.rechnerCustomConfig?.contact_person,
  );
  if (contactPerson) return contactPerson;
  return brandName;
}

/** Route-specific document title for WCAG 2.4.2. Does not touch meta description — that stays as set by nginx/lua (meta_tags API). */
export function applyRoutePageTitle(
  route: RouteLocationNormalizedLoaded,
  t: TranslateFn,
  bookingPage?: number,
): void {
  if (typeof document === "undefined") return;

  document.title = t(routeTitleKey(route, bookingPage), {
    siteName: resolveSiteName(),
  });
}
